import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '$white',
    pageBackground: '$brandBlack',
  },
  fonts: {
    body: fontStacks.switzer.value,
    heading: fontStacks.switzer.value,
  },
});

export const midnight = createTheme({ ...mergedTokens });
